<template>
  <v-container fluid>
    <v-card class="vocabcard">
      <v-card-title>{{ word.emiWord }}</v-card-title>
    </v-card>
    <h3>Gender:</h3>
    <p>{{genders[word.gender - 1]}}</p>
    <h3>[{{partsOfSpeech[word.partOfSpeech - 1]}}]</h3>
    <span v-for="(t,i_t) in word.translations">
      <p style="text-indent:10px">
        {{i_t + 1}}. {{t.translation}}
      </p>
      <p style="text-indent:30px"> Example here: A leannain ghrinn, ciamar a theirinn 
cia mheud a tha gràdh agam ort? 
- O sweet darling, how could I say 
how much I love thee?</p>
      <span v-if="i_t + 1 < word.translations.length">
        <br/>
      </span>
    </span>

  </v-container>
</template>

<script>
import { SAMPLE_VERBS } from "../constants.js";
export default {
  name: "VocabItem",
  props: {
    vocabItem: {
      type: Object,
    },
  },
  data() {
    return {
      partsOfSpeech: [
        "noun", "adjective", "verb", "adverb", "article", "preposition"
      ],
      genders: [
        "masculine", "feminine", "masculine-feminine", "none"
      ]

    };
  },
  computed: {
    word() {
      return this.$store.state.vocabulary.find(
        (w) => w.emiWord === this.$route.params.id
      );
    },
  },
};
</script>

<style scoped>
  .vocabcard {
    max-width: 50%;
    font-size: 28px;
    color: #415370;
    margin-bottom: 15px;
  }
  h3 {
    font-size: 18px;
    color: #415370;
  }
  p {
    margin-bottom: 0px !important;
  }
</style>